/* eslint-disable max-len */
import React, { SVGAttributes } from 'react';

function PurpleAngleShortLeftSVG(props: SVGAttributes<SVGSVGElement>): JSX.Element {
  return (
    <svg width={659} height={196} viewBox='0 0 659 196' fill='none' {...props}>
      <path
        transform='rotate(170.555 658.692 35.394)'
        fill='url(#prefix__paint0_linear-02)'
        d='M658.692 35.394h976.301v35.372H658.692z'
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear-02'
          x1={1634.06}
          y1={53.46}
          x2={872.366}
          y2={83.188}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#8298FC' />
          <stop offset={1} stopColor='#8298FC' stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default PurpleAngleShortLeftSVG;
